/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GreenlightSiteDTO } from '../models/GreenlightSiteDTO'
import type { GreenlightSyncConfigCreateDTO } from '../models/GreenlightSyncConfigCreateDTO'
import type { GreenlightSyncConfigDTO } from '../models/GreenlightSyncConfigDTO'
import type { GreenlightSyncConfigPatchDTO } from '../models/GreenlightSyncConfigPatchDTO'
import type { PaginatedDTO_GreenlightSyncConfigDTO_ } from '../models/PaginatedDTO_GreenlightSyncConfigDTO_'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenGreenlightSyncConfigService {
    /**
     * Index
     * @returns PaginatedDTO_GreenlightSyncConfigDTO_ Successful Response
     * @throws ApiError
     */
    public static indexGreenlightSyncConfigGet({
        page = 1,
        limit = 10,
        sort
    }: {
        page?: number
        limit?: number
        /**
         * Sort results by 'field[:asc|desc]'. Defaults to 'asc'. Example: 'name:desc', 'created_at'.
         */
        sort?: string | null
    }): CancelablePromise<PaginatedDTO_GreenlightSyncConfigDTO_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/greenlight-sync-config',
            query: {
                page: page,
                limit: limit,
                sort: sort
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Create
     * @returns GreenlightSyncConfigDTO Successful Response
     * @throws ApiError
     */
    public static createGreenlightSyncConfigPost({
        requestBody
    }: {
        requestBody: GreenlightSyncConfigCreateDTO
    }): CancelablePromise<GreenlightSyncConfigDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/aspen/greenlight-sync-config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Sites
     * Distinct patient site_ids in the caller's org (RLS-scoped), for the admin
     * UI's site-override picker. Declared BEFORE /{config_id} so "sites" isn't
     * parsed as a config id.
     * @returns GreenlightSiteDTO Successful Response
     * @throws ApiError
     */
    public static sitesGreenlightSyncConfigSitesGet(): CancelablePromise<Array<GreenlightSiteDTO>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/greenlight-sync-config/sites'
        })
    }
    /**
     * Get
     * @returns GreenlightSyncConfigDTO Successful Response
     * @throws ApiError
     */
    public static getGreenlightSyncConfigConfigIdGet({ configId }: { configId: string }): CancelablePromise<GreenlightSyncConfigDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/greenlight-sync-config/{config_id}',
            path: {
                config_id: configId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Patch
     * @returns GreenlightSyncConfigDTO Successful Response
     * @throws ApiError
     */
    public static patchGreenlightSyncConfigConfigIdPatch({
        configId,
        requestBody
    }: {
        configId: string
        requestBody: GreenlightSyncConfigPatchDTO
    }): CancelablePromise<GreenlightSyncConfigDTO> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/aspen/greenlight-sync-config/{config_id}',
            path: {
                config_id: configId
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`
            }
        })
    }
    /**
     * Delete
     * @returns string Successful Response
     * @throws ApiError
     */
    public static deleteGreenlightSyncConfigConfigIdDelete({ configId }: { configId: string }): CancelablePromise<Record<string, string>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/aspen/greenlight-sync-config/{config_id}',
            path: {
                config_id: configId
            },
            errors: {
                422: `Validation Error`
            }
        })
    }
}
